import React from 'react'
import { FieldHookConfig, useField } from 'formik'
import { FormGroup, Input, Label } from 'reactstrap'

export type CheckboxProps = FieldHookConfig<any> & {
  label: string
  id: string
  type?: 'checkbox' | 'radio'
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { label, id, type = 'checkbox', ...rest } = props
  if (typeof rest.value !== 'string' && rest.value !== undefined) {
    throw new Error('Checkbox value must be a string!')
  }
  const [field] = useField({ ...rest, type })
  return (
    <FormGroup check>
      <Input {...field} disabled={rest.disabled} id={String(id)} type={type} />
      {' '}
      <Label check for={String(id)}>
        {label}
      </Label>
    </FormGroup>
  )
}

const RadioButton: React.FC<CheckboxProps> = (props) => {
  return <Checkbox {...props} type='radio' />
}

export default Checkbox
export { RadioButton }
